/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowADownIcon16Regular = forwardRef('ArrowADownIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.25 12.068V2.715a.75.75 0 1 1 1.5 0v9.353l3.642-3.642a.75.75 0 0 1 1.06 1.061l-3.927 3.928a2.156 2.156 0 0 1-3.05 0L2.548 9.487a.75.75 0 1 1 1.06-1.06l3.642 3.641Z" })));
});
